// ©2024 Austin App House. All rights reserved.
import React from 'react';
import DatePicker from 'react-datepicker';
import FieldLabel from '../../FieldLabel';
import { parseFormDate } from '../../../../utils/getDateWithOffset';

const DatePickedField = field => {
  const selectedDate = parseFormDate(field.input.value);

  return (
    <>
      <FieldLabel
        label={field.label}
        className={field.labelClassName}
        required={field.required}
      />
      <div className="d-flex">
        <DatePicker
          disabled={field.disabled}
          className={field.inputClassName || ''}
          dateFormat={field.dateFormat}
          /* eslint-disable-next-line camelcase */
          selected={selectedDate}
          onChange={(date) => field.input.onChange(parseFormDate(date))}
          placeholder={field.label}
          style={{ marginRight: '10px' }}
          minDate={field.minDate}
          required={field.required}
          filterDate={field.filterDate}
        />
      </div>
      {
        field.meta.touched && field.meta.error
        && <span style={{ color: 'red' }} className="span-error">{field.meta.error}</span>
      }
    </>
  );
};

export default DatePickedField;
